import { LogLevel, NavigationClient, NavigationOptions } from "@azure/msal-browser";
import { ROUTES } from '@/constants/routes';
import { debugDev } from '@/logging/devConsole';

// Custom MSAL navigation client to block internal redirects back to login request URL
class NoInternalNavigationClient implements NavigationClient {
  navigateInternal(url: string, _options: NavigationOptions): Promise<boolean> {
    debugDev("MSAL blocked internal navigation to:", url);
    return Promise.resolve(false);
  }
  navigateExternal(url: string, _options: NavigationOptions): Promise<boolean> {
    debugDev("MSAL performing external navigation to:", url);
    window.location.href = url;
    return Promise.resolve(true);
  }
}

// Determine the base path where the tab is mounted (via env override or Teams path)
const basePath = import.meta.env.VITE_BASE_PATH || '';

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "211c527c-b230-4d6f-a6eb-3330d34db7a5", // from .env
    authority: "https://login.microsoftonline.com/common",
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || `${window.location.origin}/frontlinebyod/auth-redirect` // dynamic based on env
  },
  system: {
    navigationClient: new NoInternalNavigationClient(),
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
};

import { loginRequestScopes } from "../auth/scopes";

export const loginRequest = {
  scopes: loginRequestScopes
};